import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const deliveryLocationSeasonalityCache = new CacheManager('VueCache', 'cache', {
	maxAge: 24 * 60 * 60 * 1000,
	memoryCacheTTL: 30 * 60 * 1000,
	logCategory: 'DeliveryLocationSeasonality',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.deliveryLocationSeasonalities.`,
});

export async function getDeliveryLocationSeasonalities(forceRefresh = false) {
	if (!forceRefresh && !deliveryLocationSeasonalityCache.getFromMemory('all')) {
		try {
			const legacyData = await iframeDataBridge.getStorageAsync('SEASONALITIES');
			if (legacyData) {
				log('info', 'DeliveryLocationSeasonality', '📦 Seeding Vue cache from legacy storage (SEASONALITIES)');
				await deliveryLocationSeasonalityCache.put('all', legacyData);
				deliveryLocationSeasonalityCache.setInMemory('all', legacyData);
				return legacyData;
			}
		} catch (legacyError) {
			log('warn', 'DeliveryLocationSeasonality', `⚠️ Legacy storage check failed: ${legacyError.message}`);
		}
	}

	return deliveryLocationSeasonalityCache.fetchOrCache('all', fetchDeliveryLocationSeasonalitiesFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchDeliveryLocationSeasonalitiesFromAPI() {
	const response = await authenticatedFetch(getApiUrl('Sales/DeliveryLocationSeasonalities'), { method: 'GET' }, 'tokenSales');
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const seasonalities = await response.json();
	log('success', 'DeliveryLocationSeasonality', `✅ Fetched ${seasonalities.length} delivery location seasonalities`);
	return seasonalities;
}

export async function refreshDeliveryLocationSeasonalities() {
	deliveryLocationSeasonalityCache.clearMemory();
	await deliveryLocationSeasonalityCache.clear();
}
